import { Box, Divider, Typography, useTheme } from "@mui/material";
import { tokens } from '../../theme'
import { Button, CircularProgress } from "@mui/material";

import { Visibility } from "@mui/icons-material";
import { PictureAsPdf } from "@mui/icons-material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';


import { useState, useEffect } from "react";

import { djangoApi } from "../../utils/axios/axios.utils";

import Swal from "sweetalert2";

import styles from './print-promi.module.css'


const CreateNf = (props) => {
    const { data, sellerData, paymentToPitaya, nfExist, setNfExist, nfExistProd, setNfExistProd } = props;

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [prodsToSend, setProdsToSend] = useState([]);
    const [formasPagamento, setFormasPagamento] = useState([]);
    const [totalNf, setTotalNf] = useState(0);
    const [sellerDataToSend, setSellerDataToSend] = useState({});
    const [toalProdsValues, setToalProdsValues] = useState(0);


    const [isLoadingHomo, setisLoadingHomo] = useState(false);
    const [isLoadingProd, setisLoadingProd] = useState(false);

    const [isLoadingCancelNf, setIsLoadingCancelNf] = useState(false);
    const [isLoadingCartaCorrecaoNf, setIsLoadingCartaCorrecaoNf] = useState(false);

    const [isLoadingNf, setIsLoadingNf] = useState(false);

    const [cartaCorrecaoFile, setCartaCorrecaoFile] = useState(null);

    useEffect(() => {
        if (sellerData) {

            const sellerD = {
                "nome_destinatario": sellerData.nome,
                "cpf_destinatario": sellerData.cpf,
                "telefone_destinatario": sellerData.telefone.replace('+55', ''),
                "logradouro_destinatario": sellerData.end_logradouro,
                "numero_destinatario": sellerData.end_numero,
                "bairro_destinatario": sellerData.end_bairro,
                "municipio_destinatario": sellerData.end_municipio,
                "uf_destinatario": "RS",
                "pais_destinatario": "Brasil",
                "cep_destinatario": sellerData.end_cep,
            }
            setSellerDataToSend(sellerD)
        }
    }, [sellerData]);

    useEffect(() => {
        const item = {
            "unidade_comercial": "un",
            "unidade_tributavel": "un",
            "cfop": "5102",
            "icms_situacao_tributaria": "102",
            "icms_origem": "0",
            "pis_situacao_tributaria": "07",
            "cofins_situacao_tributaria": "07"
        }
        if (data) {
            const { kit_products } = data
            const soldProds = kit_products?.filter((prods) => (prods.quantity - prods.quantity_returned > 0))
            // console.log('data seller: ', soldProds.forEach(element => {
            //     console.log('element', element)
            // }))
            const itemsFormated = []
            soldProds?.filter((data) => data.content_type !== 'embalagem').forEach((prod, index) => {
                const quantitySold = prod.quantity - prod.quantity_returned
                const newObj = {
                    ...item,
                    color_prod: prod.color,
                    numero_item: index + 1,
                    codigo_produto: prod.product_id,
                    descricao: prod.color === 'Prata 925' ? prod.content_type + `${" " + prod.color}` : prod.content_type,
                    quantidade_comercial: quantitySold,
                    valor_unitario_comercial: prod.sell_price,
                    valor_unitario_tributavel: prod.sell_price,
                    quantidade_tributavel: quantitySold,
                    valor_bruto: quantitySold * prod.sell_price,
                    // codigo_ncm: prod.color === 'Prata 925' ? "71131100" : "71171900",
                    // codigo_ean: prod.color === 'Prata 925' ? "SEM GTIN" : "7896986255069",
                    // codigo_barras_tributavel: prod.color === 'Prata 925' ? "SEM GTIN" : "7896986255069",
                    // codigo_barras_comercial: prod.color === 'Prata 925' ? "SEM GTIN" : "7896986255069",
                }
                itemsFormated.push(newObj)
            });
            setProdsToSend(itemsFormated)
            const totalProdsValue = itemsFormated.reduce((acc, curr) => acc += curr.valor_bruto, 0)
            setToalProdsValues(totalProdsValue)
        }
    }, [data]);

    useEffect(() => {
        const consolidatePayments = (payments) => {
            const consolidated = payments.reduce((acc, { value, payment_method }) => {
                const method = payment_method ?? "99"; // Default to "99" if null

                if (!acc[method]) {
                    acc[method] = 0;
                }

                acc[method] += value;
                return acc;
            }, {});

            return Object.entries(consolidated).map(([forma_pagamento, valor_pagamento]) => ({
                forma_pagamento,
                valor_pagamento: valor_pagamento
            }));
        }
        const newPaymentArr = consolidatePayments(paymentToPitaya)
        setFormasPagamento(newPaymentArr)
        const totalPayments = newPaymentArr.reduce((acc, curr) => acc += curr.valor_pagamento, 0)
        setTotalNf(totalPayments)
    }, [paymentToPitaya]);


    const handleCancelNf = async (preview) => {
        const { value: userInput, isConfirmed } = await Swal.fire({
            title: "Cancelamento de Nota Fiscal",
            text: "Digite um motivo para o cancelamento:",
            icon: "warning",
            input: "textarea", // Change to textarea
            inputPlaceholder: "Digite aqui...",
            inputAttributes: {
                rows: "3", // Set input to have 3 rows
            },
            inputValidator: (value) => {
                if (!value || value.length < 15) {
                    return "O motivo deve ter pelo menos 15 caracteres.";
                }
            },
            showCancelButton: true,
            confirmButtonText: "Cancelar NF",
            cancelButtonText: "Fechar",
            reverseButtons: true, // Places confirm on the right
            customClass: {
                confirmButton: styles["swal-confirm-btn"], // Custom class for confirm
                cancelButton: styles["swal-cancel-btn"], // Custom class for cancel
            },
        });


        if (!isConfirmed) {
            setIsLoadingCancelNf(false);
            return; // If user cancels, stop execution
        }

        setIsLoadingCancelNf(true);
        console.log("User input:", userInput);


        try {
            const params = {
                homologa: preview,
                kit_id: data.kit_pk,
                justificativa: userInput
            };
            const res = await djangoApi.post(
                "products/nota_fiscal/delete_nota_fiscal/",
                params,
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            console.log('ress', res)
            if (res.status === 201) {
                await Swal.fire({
                    title: "Feito!",
                    html: "<b>Nota Fiscal Cancelada com sucesso!</b>",
                    icon: "success",
                });
                console.log(preview ? "response Homologacao:" : "response Produção:", res);
                getNf()
            }
        } catch (error) {
            if (error.response) {
                const { status, data } = error.response;
                if (status === 400) {
                    console.log("Erro ao alterar as aplicações:", data);

                    const errorMessage =
                        typeof data === "string"
                            ? data
                            : JSON.stringify(data, null, 2);

                    try {
                        await navigator.clipboard.writeText(errorMessage);
                        console.log("Erro copiado para a área de transferência!");
                    } catch (copyError) {
                        console.error("Falha ao copiar o erro:", copyError);
                    }

                    window.alert(errorMessage);
                }
            } else {
                console.error("Erro inesperado:", error);
                window.alert("Ocorreu um erro inesperado.");
            }
        } finally {
            setIsLoadingCancelNf(false);
        }
    };

    const handleCartaCorrecao = async (preview) => {

        const { value: userInput, isConfirmed } = await Swal.fire({
            title: "Emitir Carta Correção",
            text: "Digite o motivo da Carta de Correção:",
            icon: "question",
            input: "textarea", // Change to textarea
            inputPlaceholder: "Digite aqui...",
            inputAttributes: {
                rows: "6", // Set input to have 3 rows
            },
            inputValidator: (value) => {
                if (!value || value.length < 15) {
                    return "O motivo deve ter pelo menos 15 caracteres.";
                }
            },
            showCancelButton: true,
            confirmButtonText: "Emitir",
            cancelButtonText: "Fechar",
            reverseButtons: true, // Places confirm on the right
            customClass: {
                confirmButton: styles["swal-confirm-btn"], // Custom class for confirm
                cancelButton: styles["swal-cancel-btn"], // Custom class for cancel
            },
        });


        if (!isConfirmed) {
            setIsLoadingCartaCorrecaoNf(false);
            return; // If user cancels, stop execution
        }

        setIsLoadingCartaCorrecaoNf(true);
        console.log("User input:", userInput);


        try {
            const params = {
                homologa: preview,
                kit_id: data.kit_pk,
                correcao: userInput
            };
            const res = await djangoApi.post(
                "products/nota_fiscal/create_carta_correcao/",
                params,
                {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            console.log('ress', res)
            if (res.status === 201) {
                await Swal.fire({
                    title: "Feito!",
                    html: "<b>Carta de Correção Emitida com sucesso!!</b>",
                    icon: "success",
                });
                setCartaCorrecaoFile(res?.data?.carta_correcao_url);
                console.log(preview ? "response Homologacao:" : "response Produção:", res);
            }
        } catch (error) {
            if (error.response) {
                const { status, data } = error.response;
                if (status === 400) {
                    console.log("Erro ao emitir a Carta de Correção:", data);
                    const errorMessage =
                        typeof data === "string"
                            ? data
                            : JSON.stringify(data, null, 2);

                    try {
                        await navigator.clipboard.writeText(errorMessage);
                        console.log("Erro copiado para a área de transferência!");
                    } catch (copyError) {
                        console.error("Falha ao copiar o erro:", copyError);
                    }

                    window.alert(errorMessage);
                }
            } else {
                console.error("Erro inesperado:", error);
                window.alert("Ocorreu um erro inesperado.");
            }
        } finally {
            setIsLoadingCartaCorrecaoNf(false);
        }
    };


    const handleCreateNf = async (preview) => {
        const params = {
            homologa: preview,
            kit_id: data.kit_pk,
            items: prodsToSend,
            totalValue: totalNf,
            totalValueProds: toalProdsValues,
            formas_pagamento: formasPagamento,
            sellerData: sellerDataToSend,
        }
        console.log('params: ', params)
        if (preview) {
            setisLoadingHomo(true)
        } else {
            setisLoadingProd(true)
        }
        try {
            await djangoApi
                .post("products/nota_fiscal/create_nota_fiscal/", params, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    const { status } = res;
                    if (status === 201) {
                        Swal.fire({
                            title: "Feito!!",
                            html: `<b>Nota Fiscal Emitida com sucesso!!</b> `,
                            icon: "success"
                        });
                        if (preview) {
                            setisLoadingHomo(false);
                            console.log('response Homologacao: ', res);
                            setNfExist(res.data.nota_fiscal_url);
                        } else {
                            setisLoadingProd(false);
                            console.log('response Produção: ', res);
                            setNfExistProd(res.data.nota_fiscal_url);
                        }
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        const { status, data } = error.response;
                        if (status === 400) {
                            console.log("Erro ao alterar as aplicações", data);

                            // Convert the error object to a readable string
                            const errorMessage = typeof data === "string"
                                ? data
                                : JSON.stringify(data, null, 2); // Pretty-print JSON

                            // Copy to clipboard
                            navigator.clipboard.writeText(errorMessage)
                                .then(() => console.log("Erro copiado para a área de transferência!"))
                                .catch(err => console.error("Falha ao copiar o erro:", err));

                            // Show alert
                            window.alert(errorMessage);
                        }
                    } else {
                        console.error("Erro inesperado:", error);
                        window.alert("Ocorreu um erro inesperado.");
                    }
                });
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            if (preview) {
                setisLoadingHomo(false)
            } else {
                setisLoadingProd(false)
            }
        } finally {
            // pass
            if (preview) {
                setisLoadingHomo(false)
            } else {
                setisLoadingProd(false)
            }
        }
    }

    const getNf = async () => {
        const { kit_pk, nota_fiscal_url } = data
        if(nota_fiscal_url){
            setIsLoadingNf(true)
            try {
                const res = await djangoApi.get(`products/nota_fiscal/${kit_pk}/get_nota_fiscal/`, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                });
                
                if (res.status === 200) {
                    console.log("response: ", res);
                    
                    // ALTERAR PARA PRODUCAO QUNDO FOR PRA PRODUCAO
                    setNfExistProd(res.data.nota_fiscal_url);
                    // setNfExist(res.data.nota_fiscal_url);
                }
            } catch (err) {
                console.error("Erro ao buscar Nota Fiscal:", err);
            } finally {
                setIsLoadingNf(false);
            }
        } else {
            setNfExistProd(null);
        }
    }

    useEffect(() => {
        setNfExist(null)
        const getNf = async () => {
            const { kit_pk, nota_fiscal_url } = data
            if (nota_fiscal_url) {
                setIsLoadingNf(true)
                try {
                    const res = await djangoApi.get(`products/nota_fiscal/${kit_pk}/get_nota_fiscal/`, {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    });

                    if (res.status === 200) {
                        console.log("response: ", res);

                        // ALTERAR PARA PRODUCAO QUNDO FOR PRA PRODUCAO
                        setNfExistProd(res.data.nota_fiscal_url);
                        // setNfExist(res.data.nota_fiscal_url);
                    }
                } catch (err) {
                    console.error("Erro ao buscar Nota Fiscal:", err);
                } finally {
                    setIsLoadingNf(false);
                }
            } else {
                setNfExistProd(null);
            }
        }
        getNf()
    }, []);

    return (
        <>
            <Box mb={2}>
                <Typography variant="h2" color={colors.primary[100]} fontWeight={"bold"}>
                    Nota Fiscal
                </Typography>
            </Box>
            <Box sx={{ height: (nfExist || nfExistProd) && '100%', display: 'flex', gap: '20px', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '30px', justifyContent: 'space-between', width: '1200px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '30px' }}>
                        <Button
                            onClick={() => handleCreateNf(true)}
                            // disabled={isLoadingHomo || nfExistProd || totalNf === 0}
                            disabled={isLoadingHomo || nfExistProd || totalNf === 0}
                            sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1 }}
                            variant="contained"
                            color="info"
                        >
                            {isLoadingHomo ? <CircularProgress size={24} color="inherit" /> : "Preview"}
                            {!isLoadingHomo && <Visibility color="primary" />}
                        </Button>
                        <Button
                            onClick={() => handleCreateNf(false)}
                            disabled={isLoadingProd || data.is_active || nfExistProd?.length > 0 || totalNf === 0}
                            sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1 }}
                            variant="contained"
                            color="secondary"
                        >
                            {isLoadingProd ? <CircularProgress size={24} color="inherit" /> : "Emitir NF"}
                            {!isLoadingProd && <PictureAsPdf color="primary" />}
                        </Button>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '30px' }}>

                        {
                            (nfExist?.length > 0 || nfExistProd?.length > 0) &&
                            <Button
                                onClick={() => handleCartaCorrecao(false)}
                                disabled={isLoadingCartaCorrecaoNf}
                                sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1, justifySelf: 'flex-end' }}
                                variant="contained"
                                color="info"
                            >
                                {isLoadingCartaCorrecaoNf ? <CircularProgress size={24} color="inherit" /> : "Carta Correção"}
                                {!isLoadingCartaCorrecaoNf && <EditIcon color="primary" />}
                            </Button>
                        }
                        {
                            (nfExist?.length > 0 || nfExistProd?.length > 0) &&
                            <Button
                                onClick={() => handleCancelNf(false)}
                                disabled={isLoadingCancelNf}
                                sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1, justifySelf: 'flex-end' }}
                                variant="contained"
                                color="warning"
                            >
                                {isLoadingCancelNf ? <CircularProgress size={24} color="inherit" /> : "Cancelar NF"}
                                {!isLoadingCancelNf && <DeleteIcon color="primary" />}
                            </Button>
                        }
                    </Box>
                </Box>
                {
                    nfExist && !nfExistProd &&
                    <Box sx={{ height: nfExist && '100%' }}>
                        <Box sx={{ width: "1200px", height: "100%", background: "#fff", boxShadow: "0 -2px 10px rgba(0,0,0,0.1)" }}>
                            <iframe
                                src={nfExist}
                                width="100%"
                                height="100%"
                                title="PDF Viewer"
                                style={{ border: "none" }}
                            />
                        </Box>
                    </Box>
                }
                {
                    nfExistProd &&
                    <Box sx={{ height: nfExistProd && '100%' }}>
                        <Box sx={{ width: "1200px", height: "100%", background: "#fff", boxShadow: "0 -2px 10px rgba(0,0,0,0.1)" }}>
                            <iframe
                                src={nfExistProd}
                                width="100%"
                                height="100%"
                                title="PDF Viewer"
                                style={{ border: "none" }}
                            />
                        </Box>
                    </Box>
                }
                {
                    cartaCorrecaoFile &&
                    <Box sx={{ height: cartaCorrecaoFile && '100%' }}>
                        <Divider />
                        <Typography variant="h3" color={colors.primary[100]} fontWeight={"bold"} mb={1} mt={2}>
                            Carta de Correção
                        </Typography>
                        <Box sx={{ width: "1200px", height: "100%", background: "#fff", boxShadow: "0 -2px 10px rgba(0,0,0,0.1)" }}>
                            <iframe
                                src={cartaCorrecaoFile}
                                width="100%"
                                height="100%"
                                title="PDF Viewer"
                                style={{ border: "none" }}
                            />
                        </Box>
                    </Box>
                }
            </Box>
        </>
    );
}

export default CreateNf;